import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getStyles } from './ad-placements-grid-preview-style';

export function AdPlacementsGridPreview({
  cellsNumberPerRow,
  totalCount,
  onRenderCell,
  cellHeight,
}) {
  const classes = useDefaultStyles(getStyles, { cellsNumberPerRow, cellHeight });

  // we will use css to display them in grid
  const cells = [];
  for (let i = 0; i < totalCount; i += 1) {
    cells.push(<div key={i} className={classes.cellContainer}>{onRenderCell(i)}</div>);
  }

  return totalCount > 0 ? (
    <div className={classnames('ad-placements-grid', classes.gridContainer)}>
      {cells}
    </div>
  ) : null;
}

AdPlacementsGridPreview.propTypes = {
  cellsNumberPerRow: PropTypes.number.isRequired,
  totalCount: PropTypes.number.isRequired,
  onRenderCell: PropTypes.func.isRequired,
  cellHeight: PropTypes.number,
};

AdPlacementsGridPreview.defaultProps = {
  cellHeight: 482,
};
